import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName} from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: './basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ ValidationFormsService ]
})


export class BasicFormsComponent {


  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

// Timepicker

  public isEnabled: boolean = true;

  public mfData? : object = {};
  public businessTypesArray?:Array<{nameEn: string, code: string}> = [];
  public titlesArray?:Array<{nameEn: string}> = [];
  public courts?;
  public users?;
  public facilities?;
  public tapFacilityFiles?;
  isUpdate: boolean = false;
  dbFunction?: string;
  facilityId: string;
  facilityFileIds: string;
  businessType: string;
  title: string;
  licenseNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  countryCode: string;
  mobile: string;
  idFileIds: string;
  public isLoading = false;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});
  
  @ViewChild(ToastComp) toastComp: ToastComp;

  public paddingStyle: Object = { 'padding-right': '20px'};


  constructor(
    private router: Router, 
    private http: HttpClient, 
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService, 
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private storageSrv: StorageService,
    private validationSrv : ValidationService,
    public toolService: ToolService,
    ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;

    if(this.router.getCurrentNavigation().extras.state?.createData == null)
    {
      this.isUpdate = true;
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      //Call Tap retrive business
      this.facilityId = this.mfData['facilityId'];
      this.facilityFileIds = this.mfData['facilityFileIds']?.split(',');
      this.businessType = this.mfData['businessType'];
      this.title = this.mfData['title'];
      this.licenseNumber = this.mfData['licenseNumber'];
      this.firstName = this.mfData['firstName'];
      this.middleName = this.mfData['middleName'];
      this.lastName = this.mfData['lastName'];
      this.email = this.mfData['email'];
      this.countryCode = this.mfData['countryCode'];
      this.mobile = this.mfData['mobile'];
      this.idFileIds = this.mfData['idFileIds']?.split(',');
    }
    else
    {
      this.facilityFileIds = '';
      this.businessType = 'corp';
      this.title = '';
      this.licenseNumber = '';
      this.firstName = '';
      this.middleName = '';
      this.lastName = '';
      this.email = '';
      this.countryCode = '';
      this.mobile = '';
      this.idFileIds = '';
    }
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
    .then(async () => {
      this.isLoading = true;
      this.route.queryParams.subscribe(async params => {
        if (this.isUpdate) {
          this.loadTapFacilityFiles(this.facilityId);
        }
        await this.loadBusinessTypes();
        await this.loadTitles();
        await this.loadActiveFacilities();
        await this.createForm();
        if (this.isUpdate) {
          this.disableFileds();
        }
      });
    });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message : string;
  messages: string[] = [];
  updatedData = this.mfData;

  // Validators.pattern('^[0-9]{4}[\/][1-9]|1[012][\/][0-9]{2}$')]
  createForm() {
    this.simpleForm = this.fb.group({
      facilityId: [this.facilityId, [Validators.required]],
      facilityFileIds: [this.facilityFileIds, [Validators.required]],
      licenseNumber: {value: this.licenseNumber, disabled: this.isUpdate ? true : false},
      title: {value: this.title, disabled: this.isUpdate ? true : false},
      businessType: {value: this.businessType, disabled: true},
      firstName: {value: this.firstName, disabled: this.isUpdate ? true : false},
      middleName: {value: this.middleName, disabled: this.isUpdate ? true : false},
      lastName: {value: this.lastName, disabled: this.isUpdate ? true : false},
      email: {value: this.email, disabled: this.isUpdate ? true : false},
      countryCode: {value: this.countryCode, disabled: this.isUpdate ? true : false},
      mobile: {value: this.mobile, disabled: this.isUpdate ? true : false},
      idFileIds: [this.idFileIds, [Validators.required]],
    }, { });
    this.isLoading = false;
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
    else if (!this.isUpdate && this.isError == false)
    {
      this.delay(2000).then(any=>{
        this.router.navigate(['../'], {relativeTo: this.route}).then(() => {
          //window.location.reload();
        });;
      });  
    }
  }

  showError(msg) {
    //this.toasterService.pop('error', 'Error', msg);
  }

  public showPayment()
  {
    //this.router.navigate(['facility'], {state: {data: ''}, relativeTo: this.route});
    // if (this.editFlag == true)
    // {
    //   this.editFlag = false;
    // }
    // if (this.editFlag == false)
    // {
    //   this.editFlag = true;
    // }
    // this.myDivRef.nativeElement.scrollIntoView({behavior: "smooth", block: "start" });
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    return invalid;
}

saveTapOnboarding = () => {
  var facilityFileIds = this.f['facilityFileIds'].value?.toString();
  var idFileIds = this.f['idFileIds'].value?.toString();

  return new Promise<any>(async (resolve, reject) => {
    this.isLoading = true;
    const fields = {
      facilityId: this.facilityId,
      facilityFileIds: facilityFileIds,
      businessType: this.f['businessType'].value,
      licenseNumber: this.f['licenseNumber'].value,
      title: this.f['title'].value,
      firstName: this.f['firstName'].value,
      middleName: this.f['middleName'].value,
      lastName: this.f['lastName'].value,
      email: this.f['email'].value,
      countryCode: this.f['countryCode'].value,
      mobile: this.f['mobile'].value,
      idFileIds: idFileIds,
    };
    if (this.isUpdate) 
    {
      this.localInterfaceSrv.updateTapOnboarding(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Tap Onboarding Updated');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    } 
    else 
    {
      this.localInterfaceSrv.addTapOnboarding(fields)
      .then(async res => {
        resolve(res);
        this.showSuccess('Tap Onboarding Added');
      })
      .catch(err => { 
        reject(err); 
        this.toastr.error(err.desc, "Error");
      })
      .finally(() => this.isLoading = false);
    }
  });
}

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
}

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }
 

  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  loadActiveFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getActiveFacilities()
      .then(res => {
        this.facilities = res.content;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }

  loadTapFacilityFiles = (facilityId) => {
    if (!this.isUpdate) {
      this.facilityId = this.f['facilityId'].value;
    } else {
      this.facilityId = facilityId;
    }
    return new Promise<any>(async (resolve, reject) => {
      //this.isLoading = true;
      this.localInterfaceSrv.getTapFacilityFiles(this.facilityId)
      .then(res => {
        this.tapFacilityFiles = res.content;
        resolve(res);
      })
      .catch(err => { 
        reject(err); 
        this.toolService.showConsoleLog(err)
        this.toastr.error(err.desc, "Error");
      })
      .finally();
    });
  }

  loadBusinessTypes = () => {
    this.businessTypesArray.push({
      nameEn: 'Individual',
      code: 'ind'
    },
    {
      nameEn: 'Corporate',
      code: 'corp'
    });
  }

  loadTitles = () => {
    this.titlesArray.push({
      nameEn: 'Mr'
    },
    {
      nameEn: 'Mrs'
    },
    {
      nameEn: 'Ms'
    },
    {
      nameEn: 'Miss'
    },
    );
  }
  disableFileds = () => {
    //this.f['title'].setValue({value: this.title, disabled:true});
  }
}
